const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_URL || "",
  PHP_SORT_SERVIDOR: process.env.REACT_APP_PHP_SORT_SERVIDOR || "http://localhost:8081/TRS"
};

export default ENV;
  